(() => {
  document.addEventListener('cart:change', () => {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }, 1000);
  });
    
  document.addEventListener('click', (e) => {
    const quantityButton = e.target.closest('.quantity-selector__button');
    const removeButton = e.target.closest('.line-item__remove-button');
    
    if (quantityButton || removeButton) {
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }, 1000);
      
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }, 2000);
    }
  });
})();